module.exports = __webpack_public_path__ + "static/img/4410_phase_function_Paper_PointsHejduk_Prediction.c704574.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4410_phase_function_Paper_PointsHejduk_Prediction.png
// module id = MI3y
// module chunks = 0